import React from 'react';
import { Clock, MapPin, Video, FileText, Download, MessageSquarePlus, CalendarPlus, Users } from 'lucide-react';
export function NextMeeting() {
  return <section id="next-meeting" className="py-24 px-6 lg:px-8 bg-white relative overflow-hidden" data-id="element-243">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-softblue rounded-full blur-3xl opacity-50 -translate-y-1/2 translate-x-1/2" data-id="element-244"></div>
      <div className="max-w-5xl mx-auto" data-id="element-245">
        <div className="text-center mb-12" data-id="element-246">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-247">
            Próxima Reunión
          </h2>
          <p className="text-xl text-gray-600 font-medium" data-id="element-248">
            Participa en la próxima reunión comunitaria
          </p>
          <p className="text-gray-500 mt-2" data-id="element-249">
            Tu presencia ayuda a que las necesidades del vecindario sean
            escuchadas.
          </p>
        </div>

        <div className="bg-softblue rounded-3xl overflow-hidden shadow-xl border border-softblue-dark" data-id="element-250">
          <div className="bg-charcoal p-6 md:p-8 text-white flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-251">
            <div className="flex items-center gap-4" data-id="element-252">
              <div className="bg-warm text-charcoal p-4 rounded-2xl flex flex-col items-center justify-center min-w-[80px]" data-id="element-253">
                <span className="text-sm font-bold uppercase" data-id="element-254">JUN</span>
                <span className="text-3xl font-black leading-none" data-id="element-255">12</span>
              </div>
              <div data-id="element-256">
                <h3 className="text-2xl font-bold text-softblue" data-id="element-257">
                  Reunión General Comunitaria
                </h3>
                <p className="text-softblue-dark flex items-center gap-2 mt-1" data-id="element-258">
                  <Clock className="w-4 h-4" data-id="element-259" /> 6:30 PM
                </p>
              </div>
            </div>
            <div className="w-full md:w-auto" data-id="element-260">
              <button className="w-full md:w-auto bg-warm hover:bg-warm-hover text-charcoal font-bold py-3 px-6 rounded-xl transition-colors flex items-center justify-center gap-2" data-id="element-261">
                <CalendarPlus className="w-5 h-5" data-id="element-262" />
                Agregar al calendario
              </button>
            </div>
          </div>

          <div className="p-6 md:p-10" data-id="element-263">
            <div className="grid md:grid-cols-2 gap-8 mb-10" data-id="element-264">
              <div className="space-y-6" data-id="element-265">
                <div className="flex gap-4" data-id="element-266">
                  <MapPin className="w-6 h-6 text-charcoal shrink-0" data-id="element-267" />
                  <div data-id="element-268">
                    <h4 className="font-bold text-charcoal text-lg" data-id="element-269">Lugar</h4>
                    <p className="text-gray-600 notranslate" data-id="element-270">
                      Sylmar Recreation Center
                      <br data-id="element-271" />
                      13109 Borden Ave, Sylmar, CA 91342
                    </p>
                  </div>
                </div>
                <div className="flex gap-4" data-id="element-272">
                  <Video className="w-6 h-6 text-charcoal shrink-0" data-id="element-273" />
                  <div data-id="element-274">
                    <h4 className="font-bold text-charcoal text-lg" data-id="element-275">
                      Enlace virtual
                    </h4>
                    <a href="#" className="text-sky hover:text-sky-dark underline font-medium" data-id="element-276">
                      Unirse vía Zoom
                    </a>
                  </div>
                </div>
              </div>
              <div className="space-y-6" data-id="element-277">
                <div className="flex gap-4" data-id="element-278">
                  <FileText className="w-6 h-6 text-charcoal shrink-0" data-id="element-279" />
                  <div data-id="element-280">
                    <h4 className="font-bold text-charcoal text-lg" data-id="element-281">Agenda</h4>
                    <a href="#" className="text-sky hover:text-sky-dark underline font-medium" data-id="element-282">
                      Ver Agenda Oficial (PDF)
                    </a>
                  </div>
                </div>
                <div className="flex gap-4" data-id="element-283">
                  <Download className="w-6 h-6 text-charcoal shrink-0" data-id="element-284" />
                  <div data-id="element-285">
                    <h4 className="font-bold text-charcoal text-lg" data-id="element-286">
                      Documentos
                    </h4>
                    <a href="#" className="text-sky hover:text-sky-dark underline font-medium" data-id="element-287">
                      Paquete de la Junta (PDF)
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl border border-gray-100 mb-8" data-id="element-288">
              <p className="text-gray-700 text-lg text-center" data-id="element-289">
                En esta reunión podrás conocer temas importantes, escuchar
                actualizaciones, enviar comentarios y mantenerte informado sobre
                decisiones que impactan a la comunidad.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-4" data-id="element-290">
              <button className="flex items-center justify-center gap-2 bg-sky hover:bg-sky-dark text-white px-6 py-3 rounded-lg font-semibold transition-colors" data-id="element-291">
                <FileText className="w-5 h-5" data-id="element-292" /> Ver agenda
              </button>
              <button className="flex items-center justify-center gap-2 bg-charcoal hover:bg-charcoal-light text-white px-6 py-3 rounded-lg font-semibold transition-colors" data-id="element-293">
                <Video className="w-5 h-5" data-id="element-294" /> Unirme por Zoom
              </button>
              <button className="flex items-center justify-center gap-2 bg-white border-2 border-charcoal text-charcoal hover:bg-softblue px-6 py-3 rounded-lg font-semibold transition-colors" data-id="element-295">
                <MessageSquarePlus className="w-5 h-5" data-id="element-296" /> Enviar comentario
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}